import {Enums} from '_app/utils';
import {versionFilesService} from '_app/services';

export const ComplianceDownloadControl = ({id, type, mediaName}) => (
	<div className="share-control-option-container">
		<a href={versionFilesService.getDownloadUrl(id, mediaName)} download className="fa fa-download fa-1 media-share-icon undecorated">
			<span className="media-share-icon-title">{Enums.getType('fileTypes').get(type).name}</span>
		</a>
	</div>
);